import { render, staticRenderFns } from "./CertificationsTable.vue?vue&type=template&id=8ead5e88&scoped=true&"
import script from "./CertificationsTable.vue?vue&type=script&lang=js&"
export * from "./CertificationsTable.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTable.vue?vue&type=style&index=0&id=8ead5e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead5e88",
  null
  
)

export default component.exports